<sm-title-bar  pageTitle="Customer details" [backWithParams]="true">
</sm-title-bar>

<div class="customer_view_details">

   <div class="row">
     <div class="col-sm-8">
      <!-- <div class="right_deatils_pp">
        <div class="service_info">
           <div class="member_det_og">
                    <div class="service_listh" style="border: none;">
                       <div class="bus_hjk" style="border-right: 1px solid #ddd; padding-right: 28px;">
                          <h4>Last boooking
                          </h4>
                          <mat-chip-list aria-label="Fish selection">
                             <mat-chip class="primary">20 Dec 2024</mat-chip>
                          </mat-chip-list>
                       </div>
                       <div class="bus_hjk" style="padding-left: 10px;">
                        <h4>Payment due
                        </h4>
                        <mat-chip-list aria-label="Fish selection">
                           <mat-chip class="primary">₹12</mat-chip>
                        </mat-chip-list>
                     </div>
                    </div>
                  </div>
                </div>
              </div> -->
           <div class="row">
                    <div class="col-sm-6">
                       <div class="booking_card_tt">
                          <mat-card appearance="outlined">
                             <div class="price_gd">
                                <h4>675</h4>
                             </div>
                             <div class="booking_icon">
                               <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 68 68" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M56.61 66H11.39a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h45.22a4 4 0 0 1 4 4v56a4 4 0 0 1-4 4zM11.39 4a2 2 0 0 0-2 2v56a2 2 0 0 0 2 2h45.22a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" fill="#cb0b0b" opacity="1" data-original="#000000"></path><path d="M22.68 23a16.16 16.16 0 0 1-7.15-1.75 1 1 0 0 1-.56-.9 6.64 6.64 0 0 1 4.17-6 4.22 4.22 0 0 1 6.55-5.28 4.2 4.2 0 0 1 .52 5.28 7.56 7.56 0 0 1 1.86 1.16 6.31 6.31 0 0 1 2.31 4.81 1 1 0 0 1-.56.9A16.16 16.16 0 0 1 22.68 23zM17 19.76a13.25 13.25 0 0 0 11.31 0 4.39 4.39 0 0 0-1.56-2.68 6 6 0 0 0-2.63-1.26 1 1 0 0 1-.29-1.82 2.22 2.22 0 0 0 .43-3.47 2.22 2.22 0 0 0-3.83 1.55A2.22 2.22 0 0 0 21.52 14a1 1 0 0 1 .48 1 1 1 0 0 1-.78.82A5.11 5.11 0 0 0 17 19.76zM52 13.94H33.15a1 1 0 0 1 0-2H52a1 1 0 0 1 0 2zM42.59 18.9h-9.44a1 1 0 0 1 0-2h9.44a1 1 0 0 1 0 2zM22.68 41.6a16.16 16.16 0 0 1-7.15-1.75A1 1 0 0 1 15 39a6.64 6.64 0 0 1 4.17-6 4.23 4.23 0 0 1 3.54-6.58 4.31 4.31 0 0 1 3 1.29 4.25 4.25 0 0 1 1.22 3 4.17 4.17 0 0 1-.7 2.27 7.56 7.56 0 0 1 1.86 1.16A6.31 6.31 0 0 1 30.38 39a1 1 0 0 1-.56.9 16.16 16.16 0 0 1-7.14 1.7zM17 38.34a13.25 13.25 0 0 0 11.31 0 4.39 4.39 0 0 0-1.56-2.68 6 6 0 0 0-2.63-1.26 1 1 0 0 1-.78-.81 1 1 0 0 1 .47-1 2.23 2.23 0 0 0 1.08-1.89 2.24 2.24 0 1 0-4.48 0 2.22 2.22 0 0 0 1.09 1.92 1 1 0 0 1 .48 1 1 1 0 0 1-.78.82 5.11 5.11 0 0 0-4.2 3.9zM52 32.52H33.15a1 1 0 1 1 0-2H52a1 1 0 0 1 0 2zM42.59 37.48h-9.44a1 1 0 0 1 0-2h9.44a1 1 0 0 1 0 2zM22.68 60.18a16.16 16.16 0 0 1-7.15-1.75 1 1 0 0 1-.56-.9 6.64 6.64 0 0 1 4.17-6A4.23 4.23 0 0 1 22.68 45a4.31 4.31 0 0 1 3 1.29 4.25 4.25 0 0 1 1.22 3 4.17 4.17 0 0 1-.7 2.27 7.56 7.56 0 0 1 1.86 1.16 6.31 6.31 0 0 1 2.31 4.81 1 1 0 0 1-.56.9 16.16 16.16 0 0 1-7.13 1.75zM17 56.92a13.25 13.25 0 0 0 11.31 0 4.39 4.39 0 0 0-1.56-2.68A6 6 0 0 0 24.14 53a1 1 0 0 1-.78-.81 1 1 0 0 1 .47-1 2.23 2.23 0 0 0 1.08-1.89 2.24 2.24 0 1 0-4.48 0 2.22 2.22 0 0 0 1.09 1.92 1 1 0 0 1 .48 1 1 1 0 0 1-.78.82A5.11 5.11 0 0 0 17 56.92zM52 51.1H33.15a1 1 0 0 1 0-2H52a1 1 0 0 1 0 2zM42.59 56.06h-9.44a1 1 0 0 1 0-2h9.44a1 1 0 0 1 0 2z" fill="#cb0b0b" opacity="1" data-original="#000000"></path></g></svg>
                             </div>
                             <div class="booking_headingtt">
                                <h3 >See all bookings</h3>
                                <p>Access and review all your bookings in one organized view.
                                  Easily manage convenience.
                              </p>
                             </div>
                             <div class="onhover_arrow">
                              <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                            </div> 
                          </mat-card>
                       </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="booking_card_tt">
                          <mat-card appearance="outlined">
                           <div class="price_gd">
                             <h4>232</h4>
                          </div>
                          <div class="booking_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 456.212 456" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M415.008 1.59a9.95 9.95 0 0 0-5.223-1.485H111.996c-25.601 0-46.43 20.625-46.43 45.903l-1.75 256.441H10c-5.523 0-10 4.477-10 10v46.2c.035 33.925 27.527 61.417 61.453 61.456.688 0 1.379-.07 2.055-.21h248.457c1.48.105 2.973.175 4.476.175 34.454-.062 62.352-28 62.364-62.453V207.711h67.406c5.523 0 10-4.477 10-10V49.266c-.121-23.871-17.602-44.102-41.203-47.676zM20 358.652v-36.199h234.078v35.168a62.242 62.242 0 0 0 16.512 42.274H60.086c-.473.003-.941.039-1.406.109-21.754-1.48-38.653-19.547-38.68-41.352zM358.805 49.266v308.351a42.284 42.284 0 0 1-12.356 29.801 41.871 41.871 0 0 1-28.648 12.625 9.958 9.958 0 0 0-1.637-.145h-3.516c-21.78-2.144-38.425-20.386-38.57-42.273v-45.176c0-5.52-4.476-10-10-10H83.816l1.75-256.37c.145-14.462 11.965-26.083 26.43-25.974h256.742a47.735 47.735 0 0 0-9.933 29.16zM436.21 187.71h-57.406V49.266c.261-15.668 13.035-28.227 28.703-28.227s28.441 12.559 28.703 28.227zm0 0" fill="#0897c2" opacity="1" data-original="#000000" class=""></path><path d="M128.387 108.441h94.71c5.524 0 10-4.476 10-10 0-5.523-4.476-10-10-10h-94.71c-5.524 0-10 4.477-10 10 0 5.524 4.476 10 10 10zM305.059 159.941H128.387c-5.524 0-10 4.477-10 10 0 5.52 4.476 10 10 10h176.672c5.523 0 10-4.48 10-10 0-5.523-4.477-10-10-10zM305.059 231.438H128.387c-5.524 0-10 4.48-10 10 0 5.523 4.476 10 10 10h176.672c5.523 0 10-4.477 10-10 0-5.52-4.477-10-10-10zm0 0" fill="#0897c2" opacity="1" data-original="#000000" class=""></path></g></svg>
                          </div>
                             <div class="booking_headingtt">
                                <h3>See due bills/invoices</h3>
                                <p>View and track all your outstanding bills and invoices with ease.
                                  Stay updated in one convenient place.</p>
                             </div>
                             <div class="onhover_arrow">
                              <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                         </div>
                          </mat-card>
                       </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="booking_card_tt">
                          <mat-card appearance="outlined">
                          
                             <div class="booking_icon">
                              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M21 15h-4v-4a1 1 0 1 0-2 0v4h-4a1 1 0 1 0 0 2h4v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2z" fill="#0a9331" opacity="1" data-original="#000000" class=""></path><path d="M23 2H9C5.14 2 2 5.14 2 9v14c0 3.86 3.14 7 7 7h14c3.86 0 7-3.14 7-7V9c0-3.86-3.14-7-7-7zm5 21c0 2.757-2.243 5-5 5H9c-2.757 0-5-2.243-5-5V9c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5z" fill="#0a9331" opacity="1" data-original="#000000" class=""></path></g></svg>
                             </div>
                             <div class="booking_headingtt">
                                <h3>Create invoice</h3>
                                <p>Create professional invoices customizable options.
                                  Manage all your billing needs in one streamlined process.</p>
                             </div>
                             <div class="onhover_arrow">
                              <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                         </div>
                          </mat-card>
                       </div>
                    </div>
                 </div>
              
     </div>
       <div class="col-sm-4">
           <div class="salon_mei_section">
              <mat-card appearance="outlined">
                 <div class="exert_opd">
                    <div class="opert_section">
                       <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options">
                          <mat-icon>more_vert</mat-icon>
                       </button>
                       <mat-menu #menu2="matMenu">
                          <button mat-menu-item>
                             <mat-icon class="material-icons-outlined">delete</mat-icon>
                             <span>Delete customer </span>
                          </button>
                          <!-- <button mat-menu-item>
                             <mat-icon class="material-icons-outlined">payments</mat-icon>
                             <span>See all payments</span>
                          </button> -->
                        
                       </mat-menu>
                    </div>
                    <div class="salon_img">
                       <img src="https://t4.ftcdn.net/jpg/02/24/86/95/360_F_224869519_aRaeLneqALfPNBzg0xxMZXghtvBXkfIA.jpg" alt="">
                    </div>
                    <div class="hair_ct_heading">
                       <div class="rahul_headert">
                          <h4>Sumanta dutta</h4>
                          <p>+91 3495465476</p>
                       </div>
                    </div>
                    <div class="rahul_headert menbrtr">
                       <div class="new_employ">
                          <p>Gender: Male</p>
                          <p>DOB - 12 Jan 1995</p>
                          <p>Last Booking	: Jul 23, 2024</p>
                          <p>Payment Due	: 41.62</p>
                       </div>
                    </div>
                 </div>
              </mat-card>
           </div>
        </div>


   </div>
</div>



